export const phoneRecords = {
  //  Common
  title: '電話紀錄',
  subtitle: '查看所有通話記錄與詳細資訊',
  
  //  Tabs
  outboundTab: '出站紀錄',
  inboundTab: '入站紀錄',
  
  //  Outbound Page
  outboundTitle: '出站紀錄',
  outboundSubtitle: 'AI 撥打電話記錄',
  outboundPhoneLabel: 'AI 撥出使用號碼',
  
  //  Inbound Page
  inboundTitle: '入站紀錄',
  inboundSubtitle: 'AI 接聽來電記錄',
  inboundPhoneLabel: '來電接聽號碼',
  
  //  Table Columns
  taskName: '任務名稱',
  phoneNumber: '電話號碼',
  callerNumber: '來電號碼',
  callTime: '撥打時間',
  incomingTime: '來電時間',
  result: '結果',
  status: '狀態',
  duration: '通話時長',
  summary: '摘要',
  keywordSummary: '關鍵字摘要',
  viewDetails: '查看詳情',
  
  //  Status
  statusSuccess: '成功',
  statusFailed: '失敗',
  statusNoAnswer: '未接聽',
  statusConnected: '已接通',
  
  //  Filters
  filterByDate: '日期範圍',
  filterByTask: '任務名稱',
  filterByStatus: '狀態',
  allStatus: '全部狀態',
  search: '搜尋',
  reset: '重置',
  
  //  Detail Modal
  detailTitle: '通話詳情',
  basicInfo: '基本資訊',
  callSummary: '通話摘要',
  keywordTags: '關鍵字標籤',
  downloadRecording: '下載錄音',
  viewTranscript: '查看逐字稿',
  close: '關閉',
  
  //  Empty State
  noRecords: '暫無通話記錄',
  noRecordsHint: '當有通話記錄時，將會顯示在這裡',
  recording: '通話錄音',
  playRecording: '播放錄音',
  pauseRecording: '暫停播放',
};
